import { Form, Input, Button, Switch } from "antd";

import { DeviceProfileDevice } from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import { onFinishFailed } from "../helpers";

interface IProps {
  initialValues: DeviceProfileDevice;
  onFinish: (obj: DeviceProfileDevice) => void;
  disabled?: boolean;
}

function DeviceForm(props: IProps) {
  const initialValues = props.initialValues.toObject();

  const onFinish = (values: DeviceProfileDevice.AsObject) => {
    const v = Object.assign(props.initialValues.toObject(), values);

    const out = new DeviceProfileDevice();
    out.setId(v.id);
    out.setVendorId(v.vendorId);
    out.setName(v.name);
    out.setDescription(v.description);
    for (const elm of v.metadataMap) {
      out.getMetadataMap().set(elm[0], elm[1]);
    }
    out.setPublished(v.published);

    props.onFinish(out);
  };

  return (
    <Form layout="vertical" initialValues={initialValues} onFinish={onFinish} onFinishFailed={onFinishFailed}>
      <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter a device name!" }]}>
        <Input disabled={props.disabled} maxLength={100} />
      </Form.Item>
      <Form.Item label="Description" name="description">
        <Input.TextArea rows={4} disabled={props.disabled} />
      </Form.Item>
      <Form.Item
        label="Published"
        name="published"
        valuePropName="checked"
        tooltip="When unpublished, this device and all its templates are hidden from the public template API and the tenant template-picker. Cascades through the parent vendor. Editable regardless of source."
      >
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default DeviceForm;
